module.exports = __webpack_public_path__ + "media/images/TOY_DHD_Hauptgewinn-Yaris-1600-f5fe6e465af7227f835f04b916703d8f.jpg";